import { useRef, useState } from "react";
import HeaderCalendar from "./HeaderCalendar";
import DayView from "./DayView";
import WeekView from "./WeekView";
import MonthView from "./MonthView";
import DetailView from "./DetailView";

import utils from "../services/appointment";
import { useContext } from "../store/useContext";
import { useViewModeStore } from "../store/storeView";

const COMPONENT_VIEW = {
  day: DayView,
  week: WeekView,
  month: MonthView,
};

const Calendar = ({ handleDay, handleEvent, filter }) => {
  const dialogRef = useRef(null);
  const [showDialog, setShowDialog] = useState(false);

  const { context, updateContext } = useContext();
  const { viewMode } = useViewModeStore();
  const { events } = context;
  const openDialog = () => {
    setShowDialog(true);
    dialogRef.current?.showModal();
  };

  const closeDialog = () => {
    setShowDialog(false);
    dialogRef.current?.close();
  };

  const days = utils.getEventDays(context, events, viewMode);

  if (!days) {
    return null;
  }
  const CalendarView = COMPONENT_VIEW[viewMode];

  function handleDetail(e, day) {
    updateContext({ currentDate: day.day });
    openDialog();
  }
  return (
    <div className="lg:flex lg:flex-col max-h-fit">
      <HeaderCalendar handleDay={handleDay} filter={filter} />
      <div className="shadow ring-1 ring-black/5 lg:flex lg:flex-auto lg:flex-col">
        <CalendarView
          newDays={days}
          handleDay={handleDay}
          handleEvent={handleEvent}
          handleDetail={handleDetail}
        />
      </div>
      <dialog
        ref={dialogRef}
        className="rounded-xl shadow-lg p-4 w-full sm:max-w-2xl lg:max-w-7xl border border-gray-300 mx-auto my-auto ring-none"
        onCancel={closeDialog} // allows ESC key to close
      >
        {showDialog && (
          <DetailView
            newDays={days}
            handleEvent={handleEvent}
            handleDay={handleDay}
            onClose={closeDialog}
          />
        )}
      </dialog>
    </div>
  );
};

export default Calendar;
